import { onError } from '@apollo/client/link/error';
import { captureAppMessage } from './sentry';

export const apolloErrorLink = onError(({ graphQLErrors, networkError, operation }) => {
  const operationName = operation.operationName || 'anonymous';

  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      captureAppMessage(`GraphQL error in ${operationName}`, 'error', {
        operationName,
        message: err.message,
        path: err.path,
        errorType: err.extensions?.errorType,
      });
    }
  }

  if (networkError) {
    captureAppMessage(`Network error in ${operationName}`, 'error', {
      operationName,
      message: networkError.message,
      name: networkError.name,
    });
  }
});
